var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDidYouKnowGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 29",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.4,12.7c-1-6.8-6.8-11.9-14.1-11.9c-1.5,0.1-3.4,0.4-5.2,1.2C0.2,5.8-2.4,15.2,2.4,22.5c0.7,1,0.6,1.6-0.2,2.4 c-0.2,0.2-0.4,0.4-0.7,0.6c-0.5,0.4-0.7,0.9-0.9,1.6c-0.4,1.6,2.3,1.4,2.7,1.3c1.2-0.2,2.5-0.4,3.7-0.8c0.8-0.3,1.4-0.3,2.2,0 c2,0.7,4.1,1,6.3,0.7C23.2,27.3,28.5,20.3,27.4,12.7z M22.2,22.7c-3.1,3.4-8.3,4.6-12.5,2.8c-1.1-0.4-2-0.6-3.1,0.1 c-0.7,0.4-2.6,0.9-3.4,1.1c0-0.1,1.2-1.2,1.4-1.4c0.6-1.3,0.7-2.5-0.2-3.8c-2.8-4-3.1-8.4-0.6-12.6C6.2,4.5,10.1,2.6,15,3.1 c4.8,0.5,8.2,3.1,9.8,7.7C26.3,15.2,25.4,19.3,22.2,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,7.5c-2.5,0-4.1,1.4-4.1,4l1.8,0c0.1-1.4,0.8-2,2.1-2c1.2,0,2.1,0.6,2.1,1.7c0,2.4-2.8,2.4-2.8,5.7H15 c0-2.7,3.2-2.8,3.2-6C18.1,8.7,16.5,7.5,14.1,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,18.9c-0.7,0-1.3,0.5-1.3,1.3c0,0.8,0.5,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3C15.3,19.5,14.8,18.9,14.1,18.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDidYouKnowGrey);
export default __webpack_public_path__ + "static/media/did-you-know-grey.03d563d6.svg";
export { ForwardRef as ReactComponent };